import { Sport } from '@sorare/core/src/__generated__/globalTypes';

import { SORTS as FOOTBALL_SORTS } from 'searchCards/football/sorts';
import { SORTS as BASEBALL_SORTS } from 'searchCards/mlb/sorts';
import { SORTS as NBA_SORTS } from 'searchCards/nba/sorts';
import {
  scoutingCenterMarketDropdownFilters as BASEBALL_DROPDOWN_FILTERS,
  scoutingCenterMarketFilters as BASEBALL_FILTERS,
} from 'searchCommonPlayer/filtersGroup/baseball';
import {
  scoutingCenterMarketDropdownFilters as FOOTBALL_DROPDOWN_FILTERS,
  scoutingCenterMarketFilters as FOOTBALL_FILTERS,
} from 'searchCommonPlayer/filtersGroup/football';
import {
  scoutingCenterMarketDropdownFilters as NBA_DROPDOWN_FILTERS,
  scoutingCenterMarketFilters as NBA_FILTERS,
} from 'searchCommonPlayer/filtersGroup/nba';

export const SORTS_BY_SPORT = {
  [Sport.NBA]: NBA_SORTS,
  [Sport.BASEBALL]: BASEBALL_SORTS,
  [Sport.FOOTBALL]: FOOTBALL_SORTS,
};

export const FILTERS_BY_SPORT = {
  [Sport.NBA]: NBA_FILTERS,
  [Sport.BASEBALL]: BASEBALL_FILTERS,
  [Sport.FOOTBALL]: FOOTBALL_FILTERS,
};

export const DROPDOWN_FILTERS_BY_SPORT = {
  [Sport.NBA]: NBA_DROPDOWN_FILTERS,
  [Sport.BASEBALL]: BASEBALL_DROPDOWN_FILTERS,
  [Sport.FOOTBALL]: FOOTBALL_DROPDOWN_FILTERS,
};
